import { render, staticRenderFns } from "./PanelNoticias.vue?vue&type=template&id=2c3040a6&scoped=true"
import script from "./PanelNoticias.vue?vue&type=script&lang=js"
export * from "./PanelNoticias.vue?vue&type=script&lang=js"
import style0 from "./PanelNoticias.vue?vue&type=style&index=0&id=2c3040a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3040a6",
  null
  
)

export default component.exports